import type { Gitlab } from '@gitbeaker/rest'
import { createContextFunction } from '@nartex/react-libs'

export const [GitlabClientProvider, useGitlabClient] =
  createContextFunction<Gitlab>('gitlab client')
